import { withStore } from 'store';
import { withLayout } from 'hocs';
import {
  fetchExternalGiftTableProducts,
  addShoppingCartProduct,
  removeShoppingCartProduct,
  fetchShoppingCart,
  changeProductsPage,
  createShoppingCart,
} from 'store/actions/externalGiftTable';
import GuestLanding from './GuestLanding';

const actions = {
  fetchExternalGiftTableProducts,
  addShoppingCartProduct,
  removeShoppingCartProduct,
  fetchShoppingCart,
  changeProductsPage,
  createShoppingCart,
};

export default withLayout(
  withStore(
    {
      mapStateToProps: (state) => ({
        tableInfo: state.externalGiftTable.giftTableInfo.data,
        externalGiftTableProducts:
          state.externalGiftTable.externalGiftTableProducts,
        shoppingCartProducts: state.externalGiftTable.shoppingCartProducts.data,
      }),
    },
    actions
  )(GuestLanding)
);
